import { atom, useAtom } from 'jotai';

const selectedMarkerAtom = atom<string | undefined>('');
export function useSelectedMarker() {
  const [selectedMarker, setSelectedMarker] = useAtom(selectedMarkerAtom);
  return { selectedMarker, setSelectedMarker };
}
